export default __webpack_public_path__ + "2060a5107a8ac0c1d4e4c5563cc25603.svg";